import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Order } from 'contracts/Orders';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_ORDER_',
  }
);

export interface FetchOrderState {
  data: Order | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchOrderRequestAction {
  id: number;
  onSuccess?: (_?: any) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Order;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchOrderState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchOrderState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchOrderState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchOrderState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchOrderState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = (state: FetchOrderState) =>
  update(state, {
    loading: { $set: INITIAL_STATE.loading },
    data: { $set: INITIAL_STATE.data },
    errorMessage: { $set: INITIAL_STATE.errorMessage },
  });

export const fetchOrder = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchOrderTypes = Types;
export const FetchOrderActions = Creators;
